import React, { Fragment } from 'react';
import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { createGetSpecificChildren } from '../../helpers';
import { CaretRightIconSmall, IconProps } from '../../icon';
import { NakedOl } from '../../naked';
import { BreadcrumbsPath, BreadcrumbsPathComponent } from './atoms';
import { BreadcrumbsProps, BreadcrumbsProvider } from './provider';

const BREADCRUMBS_LIST = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

const BREADCRUMBS_SEPARATOR = css`
  display: flex;
  align-items: center;
`;

type BreadcrumbsChildrenTypes = 'BreadcrumbsPath';

type BreadcrumbsMainProps = {
  separator?: React.FC<React.PropsWithChildren<IconProps>> | string;
  className?: string;
} & BreadcrumbsProps;

const BreadcrumbsMain = ({ children, separator, size = 'small', className, ...rest }: BreadcrumbsMainProps) => {
  const getChild = createGetSpecificChildren<BreadcrumbsChildrenTypes>(children, true);
  const filteredChildren = getChild('BreadcrumbsPath');
  const lastItemIndex = filteredChildren.length - 1;

  const iconSizeMap = {
    small: 8,
    medium: 9,
    large: 11,
  };

  const Separator = separator ?? CaretRightIconSmall;

  return (
    <BreadcrumbsProvider size={size} {...rest}>
      <nav className={className} aria-label='Breadcrumb'>
        <NakedOl className={BREADCRUMBS_LIST}>
          {filteredChildren.map((child, index) => {
            if (index !== 0 && child) {
              return (
                <Fragment key={index}>
                  <li aria-hidden='true' key={index} className={BREADCRUMBS_SEPARATOR}>
                    {typeof separator === 'string' ? separator : <Separator size={iconSizeMap[size]} />}
                  </li>

                  {lastItemIndex === index ? React.cloneElement(child, { currentPage: true }) : child}
                </Fragment>
              );
            }
            return lastItemIndex === index ? React.cloneElement(child, { currentPage: true }) : child;
          })}
        </NakedOl>
      </nav>
    </BreadcrumbsProvider>
  );
};

type BreadcrumbsNamespace = React.FC<BreadcrumbsMainProps> & {
  Path: BreadcrumbsPathComponent;
};

const BreadcrumbsNamespace = BreadcrumbsMain as BreadcrumbsNamespace;

BreadcrumbsNamespace.Path = BreadcrumbsPath;

export { BreadcrumbsNamespace as Breadcrumbs };
